import React, { useState, useEffect, useRef } from "react";
import {
  useNavigate,
  useParams,
  useLocation,
  Link,
  Navigate,
} from "react-router-dom";
import { FaArrowLeft, FaCheckCircle, FaTimes, FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
// ///////////////////////////////////
import { feedApi } from "../../api/feedApi";
import { commentApi } from "../../api/commentApi.js";

import api from "../../api/axios";

//// Swiper for carousel ////
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Keyboard } from "swiper/modules";

import { getSidebarMenus } from "../../constants/sidebarMenus";
import { useProfile } from "../../hook/useProfile";
import CommentModal from "../../components/commentCompo/comments/CommentModal";
import TopHeader from "../../components/comman/TopHeader";
import Sidebar from "../../components/comman/Sidebar";
import ShareModal from "../../components/share/ShareModal";
import RevolutionDetailsCard from "../../components/ui/RevolutionDetailsCard/RevolutionDetailsCard";
import PostYoutubeVideo from "../../components/Post/PostYoutubeVideo";
import PostCard from "../../components/Post/PostCard";
import ReportModal from "../../components/report/ReportModal.jsx";
import Popup from "../../components/model/Popup.jsx";
import { useReport } from "../../hook/useReport.jsx";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
//// Swiper for carousel end ////

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

// CSS For PrimeFeed
import "../../css/User/Prime.css";
import { getCurrentUserId, logout } from "../../utils/auth";

//// Import Font Awesome ////
// For Solid Icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserGroup,
  faVideo,
  faImage,
} from "@fortawesome/free-solid-svg-icons";

// FOR REGULAR ICONS (bordered / outline)
import {
  faBookmark as faBookmarkRegular,
  faHeart as faHeartRegular,
  faCirclePlay as faCirclePlayRegular,
} from "@fortawesome/free-regular-svg-icons";
//// Import Font Awesome ////

//// Import Iconify for icons ////
import { Icon } from "@iconify/react";
//// Import Iconify for icons End /////

// API BASE URL
const BASE_URL = process.env.REACT_APP_BASE_URL;

// dummy user id
// const currentUserId = getCurrentUserId(); // replace with real user id later

/////////////////////////

///////////////////////////////////////////////////////////
function SharedPost() {
  const location = useLocation();

  // use reffs
  const loadMoreRef = useRef(null);
  const feedScrollRef = useRef(null);
  const { postId } = useParams();

  // user id
  const currentUserId = getCurrentUserId(); // replace with real user id later

  // link for user profile
  const profileLink = `/my/${currentUserId}/profile`;

  const { isProfileInfo } = useProfile();
  // console.log(isProfileInfo.adhaarVerified, "xyz");

  // for navigation
  const navigate = useNavigate();
  ////////////////////////////////////

  //===== refs for post form file inputs =====//
  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
  //===== refs for post form file inputs End =====//

  // ref for active video
  const activeVideoRef = useRef(null);

  // for menu toggle functionality
  const [showSidebar, setShowSidebar] = useState(true);

  // for message drawer
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);

  // SIDEBAR MENU
  const sidebarMenus = getSidebarMenus(currentUserId);

  //===== for left sidebar buttons =====//
  const [activeSidebar, setActiveSidebar] = useState("sharedPost");

  // for image modal
  const [showImageModal, setShowImageModal] = useState(false);
  const [activeImages, setActiveImages] = useState([]);

  // set feed type
  const [feedType, setFeedType] = useState("public");

  // For prime post data
  const [forYouPosts, setForYouPosts] = useState([]);

  // For public posts data
  const [publicPosts, setPublicPosts] = useState([]);

  // state for Posts
  const [post, setPost] = useState([]);
  const [sharedPost, setSharedPost] = useState(null);
  const [loading, setLoading] = useState(false);

  // function to fetch public posts
  const fetchPost = async () => {
    try {
      setLoading(true);

      const data = await feedApi.getPostById({
        postId,
      });

      setPost([data.post]);
    } catch (err) {
      console.error("Failed to fetch shared post", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (postId) {
      fetchPost();
      // console.log("iuewirwe")
    }
  }, [postId]);

  ///////////////////////////////////
  // USEEFFECT FOR COMMENT MODAL REDIRECTION from notification
  useEffect(() => {
    const openFromNotification = async () => {
      if (!location.state?.fromNotification) return;
      if (!location.state?.commentId) return;
      if (!post.length) return;

      const postData = post[0];
      await openComments(postData);

      setTimeout(() => {
        const element = document.getElementById(`comment-${location.state.commentId}`);

        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.classList.add("highlight-comment");

          setTimeout(() => {
            element.classList.remove("highlight-comment");
          }, 3000);
        }
      }, 1500);

      navigate(location.pathname, { replace: true });
    };

    openFromNotification();
  }, [post, location.state]);
  
  // USEEFFECT FOR LIKE MODAL REDIRECTION from notification
  useEffect(() => {
    if (!location.state?.fromLikeNotification) return;
    if (!post.length) return;

    const postData = post[0];

    // If not already liked, like it
    if (!postData.isLiked) {
      handleLikeToggle(postData._id);
    }

    // Highlight like button
    setTimeout(() => {
      const likeBtn = document.getElementById(`like-btn-${postData._id}`);

      if (likeBtn) {
        likeBtn.classList.add("highlight-like");

        setTimeout(() => {
          likeBtn.classList.remove("highlight-like");
        }, 2000);
      }
    }, 400);

    // Clear navigation state (VERY IMPORTANT)
    // navigate(location.pathname, { replace: true });
  }, [post]);

  ///////////////////////////////////////////////////////

  // handle logout
  const handleLogout = () => {
    logout(); // remove JWT from storage
    navigate("/login", { replace: true }); // redirect to login
  };

  ///////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////
  // post report

  const report = useReport({
    onReported: (postId) => {
      {
        feedType === "prime" &&
          setPost((prev) =>
            prev.map((p) =>
              p._id === postId ? { ...p, isReported: true } : p,
            ),
          );
      }

      {
        feedType === "public" &&
          setPost((prev) =>
            prev.map((p) =>
              p._id === postId ? { ...p, isReported: true } : p,
            ),
          );
      }
    },
  });
  // report end
  ///////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////

  //======================= comment modal start =======================//
  ////////////////////////////////////////////////////////////

  // const [showCommentModal, setShowCommentModal] = useState(false);
  const [activePost, setActivePost] = useState(null);

  // SET POST OWNER ID
  const [postOwnerId, setPostOwnerId] = useState(null);

  ////////////////////////////////////////////////////////////

  // for main comments
  const [showCommentModal, setShowCommentModal] = useState(false);
  // const [activePostId, setActivePostId] = useState(null);
  const [comments, setComments] = useState([]);
  const [commentLoading, setCommentLoading] = useState(false);

  // for replying to specific comment
  const [replyText, setReplyText] = useState("");
  const [replyTo, setReplyTo] = useState(null); // commentId
  const [repliesMap, setRepliesMap] = useState({});
  const [loadingReplies, setLoadingReplies] = useState({});

  // open comment modal
  const openComments = async (post) => {
    setActivePost(post._id);
    setPostOwnerId(post.user._id);
    setShowCommentModal(true);
    setCommentLoading(true);

    try {
      const data = await feedApi.getCommentsByPost({
        postId: post._id,
      });

      setComments(data.comments || []);
    } catch (err) {
      console.error("Fetch comments failed:", err);
    } finally {
      setCommentLoading(false);
    }
  };

  // fetch reply
  const fetchReplies = async (commentId) => {
    // TOGGLE HIDE REPLIES
    if (repliesMap[commentId]) {
      setRepliesMap((prev) => {
        const copy = { ...prev };
        delete copy[commentId];
        return copy;
      });
      return;
    }

    setLoadingReplies((prev) => ({ ...prev, [commentId]: true }));

    try {
      const data = await feedApi.getRepliesByComment({
        commentId,
      });

      setRepliesMap((prev) => ({
        ...prev,
        [commentId]: data.replies || [],
      }));
    } catch (err) {
      console.error("Fetch replies failed:", err);
    } finally {
      setLoadingReplies((prev) => ({ ...prev, [commentId]: false }));
    }
  };

  // Handle add replies
  const handleAddReply = async (parentCommentId) => {
    if (!replyText.trim()) return;

    const text = replyText;
    setReplyText(""); // optimistic clear

    try {
      const data = await feedApi.addCommentReply({
        postId: activePost,
        content: text,
        parentCommentId,
      });

      if (!data.success) return;

      const newReply = {
        ...data.comment,
        user: data.comment.user || { fullName: "You" },
      };

      // UPDATE REPLIES LIST INSTANTLY
      setRepliesMap((prev) => ({
        ...prev,
        [parentCommentId]: [...(prev[parentCommentId] || []), newReply],
      }));

      // INCREMENT REPLIES COUNT ON COMMENT
      setComments((prev) =>
        prev.map((c) =>
          c._id === parentCommentId
            ? { ...c, repliesCount: c.repliesCount + 1 }
            : c,
        ),
      );

      setReplyTo(null);
    } catch (err) {
      console.error("Reply failed:", err);
    }
  };

  // For Comment input
  const [commentText, setCommentText] = useState("");
  const [isCommentSubmitting, setIsCommentSubmitting] = useState(false);

  const replies = activePost?.comments?.filter(
    (c) => c.parentCommentId !== null,
  );

  // For comment loading simulation
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (showCommentModal) {
      setIsLoading(true);

      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [showCommentModal]);

  // comment skeleton component
  const CommentSkeleton = () => {
    return (
      <div className="comment-skeleton">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((_, i) => (
          <div className="comment-skeleton-item" key={i}>
            <div className="skeleton-avatar"></div>
            <div className="skeleton-content">
              <div className="skeleton-line short"></div>
              <div className="skeleton-line"></div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  // handle comment like
  const handleCommentLike = async (commentId) => {
    // OPTIMISTIC UPDATE
    setComments((prev) =>
      prev.map((c) =>
        c._id === commentId
          ? {
              ...c,
              isLiked: !c.isLiked,
              likesCount: c.isLiked ? c.likesCount - 1 : c.likesCount + 1,
            }
          : c,
      ),
    );

    try {
      await feedApi.likeComment({ commentId });
    } catch (err) {
      console.error(err);

      // ROLLBACK ON ERROR
      setComments((prev) =>
        prev.map((c) =>
          c._id === commentId
            ? {
                ...c,
                isLiked: !c.isLiked,
                likesCount: c.isLiked ? c.likesCount - 1 : c.likesCount + 1,
              }
            : c,
        ),
      );
    }
  };

  // add comment public feed
  const handleAddComment = async () => {
    if (!commentText.trim()) return;

    const text = commentText;
    setCommentText(""); // optimistic clear

    try {
      const data = await feedApi.addComment({
        postId: activePost,
        content: text,
      });

      if (!data.success) return;

      // MODAL COMMENTS UPDATE
      setComments((prev) => [data.comment, ...prev]);

      // FEED COMMENT COUNT UPDATE
      if (feedType === "public") {
        setPost((prev) =>
          prev.map((post) =>
            post._id === activePost
              ? { ...post, commentsCount: post.commentsCount + 1 }
              : post,
          ),
        );
      }

      if (feedType === "prime") {
        setForYouPosts((prev) =>
          prev.map((post) =>
            post._id === activePost
              ? { ...post, commentsCount: post.commentsCount + 1 }
              : post,
          ),
        );
      }
    } catch (err) {
      console.error(err);
    }
  };
  //======================= for comment modal end =======================//

  ///////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////
  // State for comment delete start
  const [activeMenuId, setActiveMenuId] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);

  // NEW
  const [deleteType, setDeleteType] = useState(null); // "comment" | "reply"
  const [parentCommentId, setParentCommentId] = useState(null);

  // If you show total comments anywhere
  const [postCommentsCount, setPostCommentsCount] = useState(0);

  const handleDeleteComment = async () => {
    try {
      await commentApi.deleteComment(deleteTargetId);

      // DELETE MAIN COMMENT
      if (deleteType === "comment") {
        setComments((prev) => prev.filter((c) => c._id !== deleteTargetId));

        // decrease post comment count instantly
        // FEED COMMENT COUNT UPDATE
        if (feedType === "public") {
          setPost((prev) =>
            prev.map((post) =>
              post._id === activePost
                ? { ...post, commentsCount: post.commentsCount - 1 }
                : post,
            ),
          );
        }

        if (feedType === "prime") {
          setForYouPosts((prev) =>
            prev.map((post) =>
              post._id === activePost
                ? { ...post, commentsCount: post.commentsCount - 1 }
                : post,
            ),
          );
        }
      }

      // DELETE REPLY
      if (deleteType === "reply") {
        // remove reply from repliesMap
        setRepliesMap((prev) => ({
          ...prev,
          [parentCommentId]:
            prev[parentCommentId]?.filter((r) => r._id !== deleteTargetId) ||
            [],
        }));

        // decrease repliesCount on parent comment
        setComments((prev) =>
          prev.map((c) =>
            c._id === parentCommentId
              ? {
                  ...c,
                  repliesCount: Math.max((c.repliesCount || 1) - 1, 0),
                }
              : c,
          ),
        );
      }

      toast.success("Deleted successfully");
    } catch (err) {
      toast.error("Failed to delete");
    } finally {
      setShowDeleteConfirm(false);
      setDeleteTargetId(null);
      setDeleteType(null);
      setParentCommentId(null);
    }
  };
  // State for comment delete end
  ///////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  // SHARE FUNCTIONALITY
  const [sharePost, setSharePost] = useState(null);

  // Open share modal
  const handleShareClick = (post) => {
    setSharePost(post);
  };

  // External share handler
  const handleInternalShare = (post) => {
    console.log("Internal share:", post._id);
    // open chat/user selection modal
    setSharePost(null);
  };

  // External share handler
  const handleExternalShare = async (post) => {
    const shareUrl = `${window.location.origin}/post/${post._id}`;

    if (navigator.share) {
      await navigator.share({
        title: "Check this post",
        url: shareUrl,
      });
    } else {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied to clipboard");
    }

    setSharePost(null);
  };

  // Handle Repost
  const handleRepost = async (post, description) => {
    try {
      const res = await api.post(`/feeds/${post._id}/repost`, {
        description: description,
      });

      const repostedPost = res.data.post;

      // setPublicPosts((prev) => [
      //     {
      //         ...repostedPost,
      //         isLiked: false,
      //         isSaved: false,
      //         isFollowing: false,
      //     },
      //     ...prev,
      // ]);

      toast.success("Post reposted");
    } catch (err) {
      const errorMsg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Something went wrong";
      toast.error(errorMsg);
    } finally {
      setSharePost(null);
    }
  };

  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////

  //======================= for public feed follow and unfollow start =======================//
  const [followLoading, setFollowLoading] = useState({});

  // Handle Follow Toggle for Both Public and Prime
  const handleFollowToggle = async (post) => {
    const userId = post.user._id;

    // // SAVE OLD STATE FOR ROLLBACK
    // const previousPosts = [...publicPosts];

    // OPTIMISTIC UPDATE
    setPost((prev) =>
      prev.map((p) => {
        if (p.user._id !== userId) return p;

        // PRIVATE ACCOUNT
        if (p.isPrivate && !p.isFollowing) {
          return {
            ...p,
            hasRequested: true,
          };
        }

        // PUBLIC ACCOUNT
        return {
          ...p,
          isFollowing: !p.isFollowing,
          followersCount: p.isFollowing
            ? p.followersCount - 1
            : p.followersCount + 1,
        };
      }),
    );

    try {
      if (post.isPrivate && !post.isFollowing) {
        // PRIVATE → REQUEST
        await feedApi.requestFollow({ userId });
      } else {
        // PUBLIC → FOLLOW / UNFOLLOW
        post.isFollowing
          ? await feedApi.unfollowUser({ userId })
          : await feedApi.followUser({ userId });
      }
    } catch (err) {
      console.error(err);

      // ROLLBACK ON ERROR
      setPost((prev) => prev.map((p) => (p.user._id === userId ? post : p)));
    }
  };
  //======================= for public feed follow and unfollow end =======================//

  //======================= for prime feed bookmark, like functionality =======================//
  // for like toggle
  const handleLikeToggle = async (postId) => {
    // OPTIMISTIC UPDATE
    {
      feedType === "public" &&
        setPost((prevPosts) =>
          prevPosts.map((post) => {
            if (post._id !== postId) return post;

            return {
              ...post,
              isLiked: !post.isLiked,
              likesCount: post.isLiked
                ? post.likesCount - 1
                : post.likesCount + 1,
            };
          }),
        );
    }
    {
      feedType === "prime" &&
        setForYouPosts((prevPosts) =>
          prevPosts.map((post) => {
            if (post._id !== postId) return post;
            return {
              ...post,
              isLiked: !post.isLiked,
              likesCount: post.isLiked
                ? post.likesCount - 1
                : post.likesCount + 1,
            };
          }),
        );
    }

    // API CALL (background)
    try {
      const res = await feedApi.toggleLike({ postId });
    } catch (error) {
      console.error("Save failed", error);
    }
  };

  // for save toggle
  // real logic with current user id
  const handleSaveToggle = async (postId) => {
    {
      feedType === "public" &&
        setPost((prev) =>
          prev.map((post) => {
            if (post._id !== postId) return post;

            return {
              ...post,
              isSaved: !post.isSaved,
            };
          }),
        );
    }

    {
      feedType === "prime" &&
        setForYouPosts((prev) =>
          prev.map((post) => {
            if (post._id !== postId) return post;

            return {
              ...post,
              isSaved: !post.isSaved,
            };
          }),
        );
    }

    // API CALL (background)
    try {
      const res = await feedApi.toggleSave({ postId });
    } catch (error) {
      console.error("Save failed", error);
    }
  };
  //======================= for prime feed bookmark, like functionality end =======================//

  ///////////////////////////////////////////////////////
  // for closing image modal on ESC key press
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setShowImageModal(false);
      }
    };

    if (showImageModal) {
      window.addEventListener("keydown", handleEsc);
    }

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [showImageModal]);
  ///////////////////////////////

  //======================= for public post edit and delete start =======================//
  // Edit modal states for feed posts
  // Edit modal
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingPost, setEditingPost] = useState(null);

  // form fields
  const [editText, setEditText] = useState("");
  const [editImages, setEditImages] = useState([]); // [{file, preview}]
  const [editVideo, setEditVideo] = useState(null); // {file, preview, duration}
  const [editVideoType, setEditVideoType] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  // Edit modal refs for feed posts
  const editImageInputRef = useRef(null);
  const editVideoInputRef = useRef(null);

  // open edit modal
  const handleEditPost = (post) => {
    setEditingPost(post);
    setEditText(post.description || "");

    // images
    if (post.images?.length) {
      setEditImages(
        post.images.map((img) => ({
          file: null, // existing image
          preview: `${img.replace(/\\/g, "/")}`,
        })),
      );
      setEditVideo(null);
      setEditVideoType("");
    }

    // video
    if (post.video) {
      setEditVideo({
        file: null,
        preview: `${post.video.replace(/\\/g, "/")}`,
        duration: post.videoDuration || 0,
      });
      setEditVideoType(post.videoDuration <= 60 ? "short" : "long");
      setEditImages([]);
    }

    setShowEditModal(true);
  };

  // handle edit image selection
  const handleEditImageSelect = (e) => {
    if (editVideo) {
      alert("Remove video to add images");
      e.target.value = "";
      return;
    }

    const files = Array.from(e.target.files);
    if (!files.length) return;

    if (files.length > 10) {
      alert("Max 10 images");
      e.target.value = "";
      return;
    }

    const imgs = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    // REPLACE old images
    setEditImages(imgs);

    // allow reselect later
    e.target.value = "";
  };

  // handle remove edit image
  const handleRemoveEditImage = (index) => {
    setEditImages((prev) => prev.filter((_, i) => i !== index));

    // reset file input so same image can be reselected
    if (editImageInputRef.current) {
      editImageInputRef.current.value = "";
    }
  };

  // handle edit video selection
  const handleEditVideoSelect = (e) => {
    if (editImages.length > 0) {
      alert("Remove images to add video");
      return;
    }

    const file = e.target.files[0];
    if (!file) return;

    const video = document.createElement("video");
    video.preload = "metadata";

    video.onloadedmetadata = () => {
      setEditVideo({
        file,
        preview: URL.createObjectURL(file),
        duration: video.duration,
      });
      setEditVideoType(video.duration <= 60 ? "short" : "long");
    };

    video.src = URL.createObjectURL(file);
  };

  // handle remove edit video
  const handleRemoveEditVideo = () => {
    setEditVideo(null);
    setEditVideoType("");
  };

  // Handle update post
  const handleUpdatePost = async () => {
    if (!editingPost) return;

    setIsUpdating(true);

    try {
      const data = await feedApi.updatePost({
        postId: editingPost._id,
        description: editText,
        images: editImages,
        video: editVideo,
      });

      const updatedPost = data.post;

      // UPDATE FEED INSTANTLY
      if (feedType === "public") {
        setPost((prev) =>
          prev.map((post) =>
            post._id === updatedPost._id ? { ...post, ...updatedPost } : post,
          ),
        );
      }

      if (feedType === "prime") {
        setForYouPosts((prev) =>
          prev.map((post) =>
            post._id === updatedPost._id ? { ...post, ...updatedPost } : post,
          ),
        );
      }

      setShowEditModal(false);
      setEditingPost(null);
    } catch (err) {
      console.error("Edit failed", err);
    } finally {
      setIsUpdating(false);
    }
  };

  // ///////////////////////
  // Hndle delete post
  const handleDeletePost = async (postId) => {
    if (!window.confirm("Delete this post?")) return;

    // OPTIMISTIC UPDATE
    {
      feedType === "public" &&
        setPost((prev) => prev.filter((p) => p._id !== postId));
    }
    {
      feedType === "prime" &&
        setForYouPosts((prev) => prev.filter((p) => p._id !== postId));
    }

    try {
      await feedApi.deletePost({ postId });
    } catch (error) {
      console.error("Delete failed", error);
      alert("Delete failed");

      // ROLLBACK / REFRESH FEED
      {
        // feedType === "public" && fetchPublicPosts(1);
      }
      {
        // feedType === "prime" && fetchPublicPosts(1);
      }
    }
  };
  //======================= post edit and delete end =======================//

  // for trending toogle
  const [showMoreTrends, setShowMoreTrends] = useState(false);

  // data for trending topics
  const trendingTopics = [
    { title: "Aaj Tak news", percent: 177, tagRank: 1 },
    { title: "UP breaking news", percent: 142, tagRank: 2 },
    { title: "India Politics", percent: 98, tagRank: 3 },
    { title: "NEWS", percent: 65, tagRank: 4 },
    { title: "Programming", percent: 120, tagRank: 5 },
    { title: "React JS", percent: 210, tagRank: 6 },
    { title: "Laravel", percent: 155, tagRank: 7 },
    { title: "JavaScript", percent: 189, tagRank: 8 },
    { title: "Latest News", percent: 134, tagRank: 9 },
  ];

  // for showing limited trends or all (Toggle)
  const visibleTrends = showMoreTrends
    ? trendingTopics
    : trendingTopics.slice(0, 5);

  // for suggested creators
  const suggestedCreators = [
    {
      id: 1,
      name: "Rohan",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
      time: "1 day ago",
      verified: true,
    },
    {
      id: 2,
      name: "Amit",
      image: "https://randomuser.me/api/portraits/men/45.jpg",
      time: "2 days ago",
      verified: true,
    },
    {
      id: 3,
      name: "Neeraj",
      image: "https://randomuser.me/api/portraits/men/12.jpg",
      time: "3 days ago",
      verified: false,
    },
    {
      id: 4,
      name: "Sandeep",
      image: "https://randomuser.me/api/portraits/men/67.jpg",
      time: "5 days ago",
      verified: true,
    },
    {
      id: 5,
      name: "Kunal",
      image: "https://randomuser.me/api/portraits/men/89.jpg",
      time: "1 week ago",
      verified: false,
    },
  ];

  // handle video play to pause other videos
  // const handleVideoPlay = (videoEl) => {
  //     if (activeMediaRef.current.el) {
  //         if (activeMediaRef.current.type === "youtube") {
  //             pauseYoutube(activeMediaRef.current.el);
  //         } else if (activeMediaRef.current.el !== videoEl) {
  //             activeMediaRef.current.el.pause();
  //         }
  //     }

  //     activeMediaRef.current = { type: "video", el: videoEl };
  // };

  /////////////////////////////////////

  console.log("NotificationPost component rendered");
  return (
    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        {/* <div className="page-container"> */}

        {/* ================= TOP HEADER NAVBAR ================= */}

        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />

        {/* ================= PRIME PUBLIC LAYOUT CONTAINER ================= */}
        <div className="prime-layout-container .container-fluid">
          <div className="row">
            {/* ================= LEFT SIDEBAR ================= */}
            {/* ===== LEFT SIDEBAR OVERLAY ===== */}
            {!showSidebar && (
              <div
                className="left-sidebar-overlay d-md-none"
                onClick={() => setShowSidebar(true)}
              />
            )}

            {/* SIDEBAR COMPONENT */}
            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              feedType={feedType}
              onNavigate={(item) => navigate(item.path)}
              onLogout={handleLogout}
            />
            {/* LEFT SIDEBAR END */}

            {/* ================= CENTER AREA ================= */}
            <div
              className="col-lg-6 col-md-9 col-12 overflow-auto center-area-container"
              ref={feedScrollRef}
            >
              <div className="center-area">
                {/* ================= FEED START ================= */}
                <div className="feed-section">
                  {/* ================= PUBLIC FEED ================= */}
                  {
                    !loading &&
                      post.map((post, index) => (
                        // ====== POST CARD COMPONENT START ====== //
                        <React.Fragment key={index}>
                          <PostCard
                            post={post}
                            currentUserId={currentUserId}
                            BASE_URL={BASE_URL}
                            followLoading={followLoading}
                            isPublic={false}
                            onReport={report.openReport}
                            handlers={{
                              onEdit: handleEditPost,
                              onDelete: handleDeletePost,
                              onLike: handleLikeToggle,
                              onSave: handleSaveToggle,
                              onShare: handleShareClick,
                              openImage: (imgs) => {
                                setActiveImages(imgs);
                                setShowImageModal(true);
                              },
                              // onVideoPlay: handleVideoPlay,
                              onFollowToggle: handleFollowToggle,
                              onComment: openComments,

                              // videoRefs,
                            }}
                          />
                        </React.Fragment>
                        // ====== POST CARD COMPONENT END ====== //
                      ))

                    // <div></div>
                  }
                </div>
                {/* ================= FEED END ================= */}
              </div>
            </div>

            {/* ================= RIGHT SIDEBAR ================= */}
            <div className="col-lg-3 d-none d-lg-block">
              <div className="sidebar-right">
                <aside className="trending-box card mb-3">
                  <p className="trending-title">
                    <span className="trending-up-icon me-1">
                      <Icon icon="ic:round-trending-up" />
                    </span>
                    Trending Topics
                  </p>

                  <ul className="trend-list">
                    {visibleTrends.map((topic, index) => (
                      <li key={index}>
                        <span>#{topic.tagRank}</span>#{topic.title}
                        <span className="trending-badge badge rounded-pill">
                          +{topic.percent}%
                        </span>
                      </li>
                    ))}
                  </ul>

                  {/* SEE MORE BUTTON */}
                  <p
                    className="see-more-btn text-center mt-2 mb-0"
                    onClick={() => setShowMoreTrends(!showMoreTrends)}
                  >
                    {showMoreTrends ? "See Less" : "See More"}
                  </p>
                </aside>

                <aside className="trending-box card mb-3">
                  <p className="trending-title">
                    <span className="me-1">
                      <FontAwesomeIcon icon={faUserGroup} />
                    </span>{" "}
                    Follow Suggestions
                  </p>
                  <ul className="suggested-creators-list">
                    {suggestedCreators.map((creator) => (
                      <li key={creator.id}>
                        <div className="post-header">
                          <img
                            src={creator.image}
                            className="user-img"
                            alt={creator.name}
                          />

                          <div>
                            <p className="username">
                              {creator.name}
                              {creator.verified && (
                                <span className="feed-verified-badge ms-1">
                                  <Icon icon="ic:baseline-verified" />
                                </span>
                              )}
                            </p>

                            <p className="group-name">{creator.time}</p>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </aside>
              </div>
            </div>
          </div>
        </div>

        {/* =========== IMAGE MODAL START =========== */}
        {showImageModal && (
          <div className="image-modal">
            <span
              className="close-modal"
              onClick={() => setShowImageModal(false)}
            >
              ×
            </span>

            <Swiper
              modules={[Navigation, Pagination, Keyboard]}
              navigation
              pagination={{ clickable: true }}
              keyboard={{ enabled: true }}
              spaceBetween={20}
              slidesPerView={1}
              className="image-swiper"
            >
              {activeImages.map((img, index) => (
                <SwiperSlide key={index}>
                  <TransformWrapper
                    pinch={{ disabled: false }}
                    doubleClick={{ disabled: false }}
                    wheel={{ step: 0.1 }}
                  >
                    <TransformComponent>
                      <img
                        // src={`${img}`}
                        src={`${img.replace(/\\/g, "/")}`}
                        className="modal-image"
                        alt="post"
                      />
                    </TransformComponent>
                  </TransformWrapper>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
        {/* =========== IMAGE MODAL END =========== */}

        {/* =========== POST EDIT MODAL START =========== */}
        {showEditModal && (
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div className="modal-content shadow-lg post-edit-modal-container">
                {/* HEADER */}
                <div className="modal-header">
                  <h5 className="modal-title">Edit Post</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowEditModal(false)}
                  />
                </div>

                {/* BODY */}
                <div className="modal-body">
                  {/* TEXT */}
                  <textarea
                    className="form-control mb-3"
                    rows={3}
                    value={editText}
                    onChange={(e) => setEditText(e.target.value)}
                    placeholder="Edit your post..."
                  />

                  {/* IMAGE PREVIEW */}
                  {editImages.length > 0 && (
                    <div className="image-preview-box">
                      {editImages.map((img, i) => (
                        <div key={i} className="preview-image-wrapper">
                          <img src={img.preview} className="preview-image" />
                          <span
                            className="remove-img"
                            onClick={() => handleRemoveEditImage(i)}
                          >
                            ×
                          </span>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* VIDEO PREVIEW */}
                  {editVideo && (
                    <div className="video-preview-box">
                      <div className="preview-video-wrapper">
                        <video
                          src={editVideo.preview}
                          controls
                          className="video-preview"
                        />
                        <span className="video-type-label">
                          {editVideoType === "short"
                            ? "🎬 Short Video"
                            : "🎥 Long Video"}
                        </span>
                        <span
                          className="remove-video"
                          onClick={handleRemoveEditVideo}
                        >
                          ×
                        </span>
                      </div>
                    </div>
                  )}

                  {/* MEDIA BUTTONS */}
                  <div className="d-flex gap-3 mt-3">
                    <label>
                      <FontAwesomeIcon icon={faImage} />
                      <input
                        ref={editImageInputRef}
                        type="file"
                        multiple
                        accept="image/*"
                        hidden
                        onChange={handleEditImageSelect}
                      />
                    </label>

                    <label>
                      <FontAwesomeIcon icon={faVideo} />
                      <input
                        ref={editVideoInputRef}
                        type="file"
                        accept="video/*"
                        hidden
                        onChange={handleEditVideoSelect}
                      />
                    </label>
                  </div>
                </div>

                {/* FOOTER */}
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowEditModal(false)}
                    disabled={isUpdating}
                  >
                    Cancel
                  </button>

                  <button
                    className=" btn upload-btn"
                    onClick={handleUpdatePost}
                    disabled={isUpdating}
                  >
                    {isUpdating ? "Updating..." : "Update Post"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* =========== POST EDIT MODAL END =========== */}

        {/* =========== COMMENT MODAL START =========== */}
        <CommentModal
          show={showCommentModal}
          onClose={() => setShowCommentModal(false)}
          comments={comments}
          commentLoading={commentLoading}
          BASE_URL={BASE_URL}
          currentUserId={currentUserId}
          postOwnerId={postOwnerId}
          commentText={commentText}
          setCommentText={setCommentText}
          replyText={replyText}
          setReplyText={setReplyText}
          replyTo={replyTo}
          setReplyTo={setReplyTo}
          onAddComment={handleAddComment}
          onAddReply={handleAddReply}
          onLikeComment={handleCommentLike}
          onFetchReplies={fetchReplies}
          onDelete={handleDeleteComment}
          repliesMap={repliesMap}
          loadingReplies={loadingReplies}
          activeMenuId={activeMenuId}
          setActiveMenuId={setActiveMenuId}
          showDeleteConfirm={showDeleteConfirm}
          setShowDeleteConfirm={setShowDeleteConfirm}
          deleteType={deleteType}
          setDeleteTargetId={setDeleteTargetId}
          setDeleteType={setDeleteType}
          setParentCommentId={setParentCommentId}
          onReport={report.openReport}
        />
        {/* =========== COMMENT MODAL END =========== */}

        {/* =========== MESSAGE DRAWER START =========== */}
        {/* Msg Drawer */}
        {showMsgDrawer && (
          <>
            <div
              className="msg-overlay"
              onClick={() => setShowMsgDrawer(false)}
            ></div>

            <div className="msg-drawer">
              <div className="msg-header">
                <h3>Chats</h3>
                <span onClick={() => setShowMsgDrawer(false)}>✕</span>
              </div>

              <div className="msg-search">
                <input placeholder="Search Messenger" />
              </div>

              <div className="msg-tabs">
                <span className="active">All</span>
                <span>Unread</span>
                <span>Groups</span>
                <span>Communities</span>
              </div>

              <div className="msg-empty">
                <h4>No chats</h4>
                <p>When you have chats, you’ll see them here.</p>
              </div>

              <div
                className="msg-footer"
                onClick={() => {
                  setShowMsgDrawer(false);
                  navigate("/message");
                }}
              >
                See all in Messenger
              </div>
            </div>
          </>
        )}
        {/* =========== MESSAGE DRAWER END =========== */}

        {/* =========== SHARE MODAL START =========== */}
        <ShareModal
          post={sharePost}
          onClose={() => setSharePost(null)}
          onInternalShare={handleInternalShare}
          onExternalShare={handleExternalShare}
          onRepost={handleRepost}
        />
        {/* =========== SHARE MODAL END =========== */}

        {/* =========== REPORT MODAL END =========== */}
        <ReportModal
          show={report.showModal}
          step={report.step}
          reason={report.reason}
          subReason={report.subReason}
          setReason={report.setReason}
          setSubReason={report.setSubReason}
          onNext={() => report.setStep(2)}
          onBack={() => {
            report.setSubReason(null);
            report.setStep(1);
          }}
          onSubmit={report.submitReport}
          loading={report.loading}
          onClose={() => report.setShowModal(false)}
        />
        {/* =========== REPORT MODAL END =========== */}
      </div>
    </div>
  );
}
export default SharedPost;
